import React, { useState, useEffect } from "react";
import ChatWindow from "../components/ChatWindow";
import LoginModal from "../components/LoginModal";
import { useLocation } from "react-router-dom";

function Home() {
  const [showModal, setShowModal] = useState(false);

  const pathName = useLocation().pathname;
  useEffect(() => {
    const userData = localStorage.getItem("userData");
    if (!userData) setShowModal(true);
  }, [pathName]);

  return (
    <>
      <ChatWindow />
      {/* <LoginModal showModal={showModal} setShowModal={setShowModal} /> */}
    </>
  );
}

export default Home;
